module.exports = ".ql-container .ql-editor {\n  min-height: 200px;\n  padding-bottom: 1rem;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/ngx-quill-editor/quillEditor.component.css
// module id = ./node_modules/ngx-quill-editor/quillEditor.component.css
// module chunks = vendor